"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var ga_1 = require("../../utils/ga");
var SaleStickerSvg_1 = require("../EmailExclusives/SaleStickerSvg");
var CtaButton_1 = require("../common/Btn/CtaButton");
var EmailExclusivesProductCard = function (_a) {
    var isBundle = _a.isBundle, product = _a.product, bundleDiscount = _a.bundleDiscount;
    var featured_image = product.featured_image, handle = product.handle, metafields = product.metafields, variants = product.variants, title = product.title;
    var isSubscription = product.selling_plan_groups.length;
    var subheaderText = metafields.text;
    if (metafields.shop_style === 'single-bundle' || metafields.sub_collection === 'bundles') {
        subheaderText = 'Bundle to Save';
    }
    var prodImg = '';
    if (isBundle) {
        prodImg = "https:".concat(metafields.sale_image);
    }
    else {
        prodImg = "https://".concat(featured_image);
    }
    var hasReview = true;
    if (product.handle == 'revitalizing-sex-collections' ||
        product.handle == 'revitalizing-sex-collection' ||
        product.handle == 'happy-body-bundles' ||
        product.handle == 'fit-free-kits' ||
        product.handle == 'vaginal-urinary-health-bundle' ||
        product.handle == 'get-your-body-back-bundle' ||
        product.handle == 'fountain-of-youth-collections' ||
        product.handle == 'metabolism-period-bundle' ||
        product.handle == 'menopause-gut-kit' ||
        product.handle == 'feel-lighter-bundle' ||
        product.handle == 'hormone-balance-kits') {
        hasReview = false;
    }
    // the sticker shows the total amount of discount after applying the discount code
    // total amount of discount = original price of 3/4/6 packs - bundle's price shown on bundle page after having 15% discount
    // e.g. bundles of 6 uro = $192;
    //      uro bundle on its page priced: $144
    //      discount code applied 15% off
    //      finalDiscount = 192 - (144 * (100-15)%)
    var finalDiscount = bundleDiscount &&
        +((product.compare_at_price_max - (product.price_max * (100 - bundleDiscount)) / 100) /
            100).toFixed(0);
    // for 2.0 ab testing
    var targetUrl = "https://opositiv.com/products/".concat(handle);
    var handleClickAdd = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, sellingPlanId, productVariant, response, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    data = new FormData();
                    sellingPlanId = (_b = (_a = product.selling_plan_groups[0]) === null || _a === void 0 ? void 0 : _a.selling_plans[0]) === null || _b === void 0 ? void 0 : _b.id;
                    productVariant = product.variants[product.variants.length - 1];
                    data.append('quantity', '1');
                    data.append('id', "".concat(productVariant.id));
                    if (sellingPlanId) {
                        data.append('selling_plan', "".concat(sellingPlanId));
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch('/cart/add.js', {
                            method: 'POST',
                            body: data,
                        })];
                case 2:
                    response = _c.sent();
                    document.dispatchEvent(new Event('fetchAndSlideCart'));
                    (0, ga_1.sendItemEventInCartOld)(product, productVariant, 'add_to_cart', 'shop_all');
                    window.klaviyo.push([
                        'track',
                        'Added to Cart',
                        {
                            ProductID: product.id,
                            ProductName: product.title,
                            ImageURL: "https:".concat(product.featured_image),
                            URL: window.location.origin + window.location.pathname,
                        },
                    ]);
                    return [2 /*return*/, response];
                case 3:
                    err_1 = _c.sent();
                    console.error(err_1);
                    return [2 /*return*/, 0];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { class: "shop-all-product" },
            (0, preact_1.h)("a", { class: "shop-all-product__link-to-collection", href: "".concat(targetUrl) }),
            metafields.sale_description && ((0, preact_1.h)("div", { class: "shop-all-product__banner" }, metafields.sale_description)),
            (0, preact_1.h)("a", { class: "shop-all-product__link", href: "".concat(targetUrl) },
                (0, preact_1.h)("img", { alt: title, class: "shop-all-product__image", src: prodImg, width: 174, loading: window.isLazyVPTest ? 'lazy' : 'eager' }),
                isBundle && (0, preact_1.h)(SaleStickerSvg_1.default, { saleAmount: finalDiscount, product: product })),
            (0, preact_1.h)("div", { class: "shop-all-product__content-wrapper" },
                (0, preact_1.h)("a", { class: "shop-all-product__product-info", href: "".concat(targetUrl) },
                    (0, preact_1.h)("div", { class: "shop-all-product__header-wrapper" },
                        hasReview && ((0, preact_1.h)("div", { class: "shop-all-product__yotpo" },
                            (0, preact_1.h)("div", { class: "yotpo bottomLine", "data-product-id": product.id }))),
                        (0, preact_1.h)("a", { class: "shop-all-product__header", href: "".concat(targetUrl) },
                            (0, preact_1.h)("p", null,
                                metafields.header1.replace(/<[^>]+>/g, ''),
                                " ",
                                metafields.header2))),
                    (0, preact_1.h)("div", { class: "shop-all-product__subheader" },
                        (0, preact_1.h)("p", null, subheaderText)),
                    (0, preact_1.h)("div", { class: "shop-all-product__price" },
                        (0, preact_1.h)("p", { class: "shop-all-product__grey" }, "$".concat(product.compare_at_price / 100)),
                        (0, preact_1.h)("p", null, "$".concat(variants[variants.length - 1].price / 100),
                            isSubscription ? '/mo' : ''))),
                (0, preact_1.h)("div", { class: "shop-all-product__add" },
                    (0, preact_1.h)(CtaButton_1.default, { backgroundColor: {
                            to: 'Left',
                            startColor: 'orange',
                            endColor: 'orange',
                        }, hoverColor: "white", text: "EXPLORE MORE", scrollTo: "".concat(targetUrl), size: "medium" })),
                (0, preact_1.h)("button", { onClick: handleClickAdd, class: "shop-all-product__explore" }, "+ Quick Add")))));
};
exports.default = EmailExclusivesProductCard;
